// extracted by mini-css-extract-plugin
export default {"loading":"Loading-module--loading--pSirk","spinner":"Loading-module--spinner--hI45Z","load6":"Loading-module--load6--JkBGa","round":"Loading-module--round--hJULU"};